import React, {useState} from 'react';
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemSecondaryAction,
  ListItemText,
  Switch,
} from '@mui/material';
import {LayersOutlined as LayersOutlinedIcon} from '@mui/icons-material';
import {bool, func, oneOf} from 'prop-types';

import MapPopper from './MapPopper.jsx';
import MapTool from './MapTool.jsx';
import darkPreview from './assets/dark_preview_60x60.png';
import lightPreview from './assets/light_preview_60x60.png';
import satellitePreview from './assets/satellite_preview_60x60.jpeg';
import {BASE_LAYERS} from './constants.js';
import {useMapAuth} from './context/MapAuthProvider.jsx';

const LAYERS_LABELS = {
  [BASE_LAYERS.SATELLITE]: 'Satellite',
  [BASE_LAYERS.DARK]: 'Dark',
  [BASE_LAYERS.LIGHT]: 'Light',
  labels: 'Labels and borders',
};

const PREVIEW_STYLES = {
  satellite: satellitePreview,
  light: lightPreview,
  dark: darkPreview,
};

const LayerSwitcher = ({
  selectedBackground,
  onBackgroundChange,
  labelsOn,
  onLabelsChange,
  onClick,
  // open,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const {authToken} = useMapAuth();

  return (
    <>
      <MapTool
        data-testid="layer-switcher"
        tooltip="Map layers"
        tooltipPosition="left-end"
        active={isOpen}
        icon={<LayersOutlinedIcon />}
        onClick={event => {
          setAnchorEl(event.currentTarget);
        }}
        {...props}
      />
      <MapPopper
        title="Layers"
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <List disablePadding dense>
          {Object.values(BASE_LAYERS)
            .filter(overlay => {
              if (!authToken && overlay === BASE_LAYERS.SATELLITE) {
                return false;
              }
              return true;
            })
            .map(overlay => {
              const selected = selectedBackground === overlay;

              return (
                <ListItemButton
                  key={overlay}
                  selected={selected}
                  onClick={() => {
                    onBackgroundChange(overlay);
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      src={PREVIEW_STYLES[overlay]}
                      sx={{
                        borderRadius: 1,
                        border: '2px solid',
                        borderColor: theme =>
                          selected ? theme.palette.primary.main : 'transparent',
                      }}
                    />
                  </ListItemAvatar>
                  <ListItemText primary={LAYERS_LABELS[overlay]} />
                </ListItemButton>
              );
            })}
          <ListItem>
            <ListItemText primary={LAYERS_LABELS.labels} />
            <ListItemSecondaryAction sx={{right: 0}}>
              <Switch
                color="primary"
                edge="end"
                onChange={() => onLabelsChange(!labelsOn)}
                checked={labelsOn}
              />
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </MapPopper>
    </>
  );
};

LayerSwitcher.propTypes = {
  selectedBackground: oneOf(['dark', 'light', 'satellite']),
  onBackgroundChange: func,
  labelsOn: bool,
  onLabelsChange: func,
  onClick: func,
  open: bool,
};

LayerSwitcher.defaultProps = {
  labelsOn: true,
  selectedBackground: 'dark',
};

export default LayerSwitcher;
